// extracted by mini-css-extract-plugin
export default {"button":"io-z","reviewSort":"jo-z"};